import { api } from '../../services/api'

const state = () => ({
  items: [],
  loading: false,
  error: null
})

const getters = {
  all: (s) => s.items
}

const mutations = {
  SET_ITEMS(state, items) {
    console.log("MUTATION: SET_ITEMS", items)
    state.items = items
  },

  ADD_ITEM(state, item) {
    console.log("MUTATION: ADD_ITEM", item)
    state.items.unshift(item)
  },

  UPDATE_ITEM(state, item) {
    console.log("MUTATION: UPDATE_ITEM", item)

    const i = state.items.findIndex(x => String(x.id) === String(item.id))
    if (i !== -1) {
      state.items.splice(i, 1, item)
      console.log("Item Updated at index:", i)
    } else {
      console.log("Item not found for update")
    }
  },

  REMOVE_ITEM(state, id) {
    console.log("MUTATION: REMOVE_ITEM", id)

    state.items = state.items.filter(x => String(x.id) !== String(id))
  },

  SET_LOADING(state, v) {
    console.log("MUTATION: SET_LOADING", v)
    state.loading = v
  },

  SET_ERROR(state, e) {
    console.log("MUTATION: SET_ERROR", e)
    state.error = e
  }
}

const actions = {

  async list({ commit }) {
    commit('SET_LOADING', true)
    try {
      console.log("Fetching header-section from admin API")
      const { data } = await api.get('admin/header-section')
      console.log("Final Data Received:", data)
      commit('SET_ITEMS', Array.isArray(data) ? data : (data?.items || []))
      commit('SET_ERROR', null)
    } catch (e) {
      console.error("ERROR in list():", e)
      commit('SET_ERROR', e.message || 'Failed to load')
    } finally {
      commit('SET_LOADING', false)
    }
  },



  async create({ commit }, payload) {

    console.log("ACTION: create()", payload)

    const form = new FormData()

    if (payload.logo_text) {
      console.log("Adding logo_text:", payload.logo_text)
      form.append('logo_text', payload.logo_text)
    }

    if (payload.address) {
      console.log("Adding address:", payload.address)
      form.append('address', payload.address)
    }

    if (payload.phone) {
      console.log("Adding phone:", payload.phone)
      form.append('phone', payload.phone)
    }

    if (payload.logoFile) {
      console.log("Adding logo file")
      form.append('image', payload.logoFile)
    }
    else if (payload.logo_image) {
      console.log("Adding logo_image path:", payload.logo_image)
      form.append('logo_image', payload.logo_image)
    }

    if (payload.faviconFile) {
      console.log("Adding favicon file")
      form.append('favicon', payload.faviconFile)
    }
    else if (payload.favicon_image) {
      console.log("Adding favicon path:", payload.favicon_image)
      form.append('favicon_image', payload.favicon_image)
    }

    console.log("Sending POST request...")

    const { data } = await api.post('admin/header-section', form)

    console.log("Create Response:", data)

    commit('ADD_ITEM', data)

    return data
  },



  async update({ commit }, { id, payload }) {

    console.log("ACTION: update()", id, payload)

    const form = new FormData()

    if (payload.logo_text) form.append('logo_text', payload.logo_text)
    if (payload.address) form.append('address', payload.address)
    if (payload.phone) form.append('phone', payload.phone)

    if (payload.logoFile) {
      console.log("Updating logo file")
      form.append('image', payload.logoFile)
    }
    else if (payload.logo_image) {
      form.append('logo_image', payload.logo_image)
    }

    if (payload.faviconFile) {
      console.log("Updating favicon file")
      form.append('favicon', payload.faviconFile)
    }
    else if (payload.favicon_image) {
      form.append('favicon_image', payload.favicon_image)
    }

    console.log("Sending PUT request...")

    const { data } = await api.put(`admin/header-section/${id}`, form)

    console.log("Update Response:", data)

    commit('UPDATE_ITEM', data)

    return data
  },



  async remove({ commit }, id) {

    console.log("ACTION: remove()", id)

    await api.delete(`admin/header-section/${id}`)

    console.log("Delete success")

    commit('REMOVE_ITEM', id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}